import React, { Component } from 'react';
import Page500 from 'views/Pages/Page500';
import _ from 'lodash';
import * as Sentry from '@sentry/react';

class ErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.state = {
            hasError: false
        }

        _.bindAll(
            this,
            'onRedirect'
        )
    }
    static getDerivedStateFromError() {
        return { hasError: true };
    }

    componentDidCatch(error, errorInfo) {
        Sentry.captureException(error, {
            extra: {
                componentStack: errorInfo?.componentStack,
            },
        });
    }

    onRedirect() {
        /**
         * added delay because this state updates before redirect 
         * and the same component that thrown error may render again
         *  */ 
        setTimeout(() => {
            this.setState({
                hasError: false
            })
        }, 50);
    }
    render() {
        const { children } = this.props;
        const { hasError } = this.state;

        if (hasError) {
            return <Page500 onRedirect={this.onRedirect} />
        }

        return children;
    }
}

export default ErrorBoundary;
